import { Breadcrumb, Form, Table } from 'antd';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import { Panel } from 'src/components/Panel';

import { marketingActivityQuery } from '../group/GroupDetail';
import { AddMarketingActivity } from './AddMarketingActivity';

const AddMarketingActivityForm = Form.create()(AddMarketingActivity);

interface MarketingActivity {
  id: number;
  name: string;
}

export enum MarketActivityStatus {
  NEW,
  ONLINE,
  OFFLINE,
}

export enum MarketActivityType {
  UNKNOWN,
  POINT,
  PREORDER,
  NEW_POINT,
  LIMITED_TIME_SALE,
  RESERVATION,
  SLM_DISCOUNT,
  GIFT_COURSE,
  DOUBLE_11,
}

interface Props {}
interface State {}
export class MarketingActivityList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>活动管理</Breadcrumb.Item>
        </Breadcrumb>
        <Panel style={{ padding: '20px' }}>
          <AddMarketingActivityForm />
        </Panel>
        <Panel style={{ marginTop: 10 }}>
          <Query query={marketingActivityQuery}>
            {({ error, data }) => {
              if (error) return <div>{error.message}</div>;
              const marketingActivities = (data && data.marketingActivities) || [];
              return (
                <Table<MarketingActivity>
                  dataSource={marketingActivities}
                  rowKey={row => `${row.id}`}
                  pagination={false}
                >
                  <Table.Column dataIndex="id" title="ID" key="id" />
                  <Table.Column dataIndex="name" title="名称" key="name" />
                  <Table.Column dataIndex="desc" title="描述" key="desc" />
                  <Table.Column dataIndex="weight" title="活动优先级" key="weight" />
                  <Table.Column
                    title="操作"
                    key="actions"
                    render={row => <Link to={`activity/setting/${row.name}/${row.id}`}>活动配置</Link>}
                  />
                </Table>
              );
            }}
          </Query>
        </Panel>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/marketing/MarketActivites.tsx